import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Bubble from "../module-common/Bubble";
import moment from "moment";

export default class ContentBubble extends Component {
  static propTypes = {
    content: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    fromAgent: PropTypes.bool,
    timestamp: PropTypes.instanceOf(moment),
    isAgent: PropTypes.bool,
    showTimestamp: PropTypes.bool
  };

  render() {
    const { content, timestamp, fromAgent, showTimestamp, mediaList } = this.props;
    return (
      <ContentSec>
        <Padding isAgent={fromAgent}>
          <Bubble
            isAgent={fromAgent}
            content={content}
            timestamp={timestamp}
            showTimestamp={showTimestamp}
            mediaList={mediaList}
          />
        </Padding>
      </ContentSec>
    );
  }
}

const ContentSec = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  align-items: center;
`;

const Padding = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: ${props => (props.isAgent ? "row" : "row-reverse")};
  align-self: center;
`;
